import * as React from "react";
import { toJS } from "mobx";
import { MarketTemplate } from "../../../../../data";
import { prepareEmptyMarket } from "../../../../../helpers";
import { renderOutrightBetButtons } from "./renderOutrightBetButtons";
export const renderOutrightMarkets = (props, buttonsHolderClass, componentPrefix) => {
    const market = (props.markets && props.markets.length > 0)
        ? toJS(props.markets[0])
        : prepareEmptyMarket(props.event.id, MarketTemplate.ThreeBox, 0);
    market.template = MarketTemplate.ThreeBox;
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${props.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, renderOutrightBetButtons(props, market, componentPrefix)));
};
//# sourceMappingURL=renderOutrightMarkets.js.map